import { useState } from "react";
import { Download, Printer } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { useDownload } from "@/lib/libraryApi";

const FORMATS = ["pdf", "docx", "csv", "json"];
const VERSIONS = ["learner", "teacher", "answer_key", "teacher_guide"];

// Teacher versions exist only where the server allows them; learner surfaces pass teacher={false}.
export default function ExportMenu({ base, teacher = false, lang, name = "asset" }) {
  const { t } = useI18n();
  const download = useDownload();
  const [version, setVersion] = useState("learner");
  const q = (fmt) => `${base}?format=${fmt}&version=${version}${lang ? `&lang=${lang}` : ""}`;
  const print = async () => {
    const w = window.open("", "_blank");
    try {
      const r = await api.get(q("html"), { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data], { type: "text/html" }));
      if (w) w.location = url; else window.location.assign(url);
    } catch { w?.close(); toast.error(t("al.failed")); }
  };
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="asset-export">
      {teacher && (
        <select className="nb-input w-auto py-1 text-xs" value={version} onChange={(e) => setVersion(e.target.value)} aria-label={t("al.p.exportVersion")} data-testid="export-version">
          {VERSIONS.map((v) => <option key={v} value={v}>{t(`al.p.ver.${v}`)}</option>)}
        </select>
      )}
      {FORMATS.map((f) => (
        <button key={f} onClick={() => download(q(f), `${name}_${version}.${f}`)} className="nb-tag bg-white text-xs" data-testid={`export-${f}`}><Download className="w-3 h-3 inline" /> {f.toUpperCase()}</button>
      ))}
      <button onClick={print} className="nb-tag bg-white text-xs" data-testid="export-print"><Printer className="w-3 h-3 inline" /> {t("al.p.print")}</button>
    </div>
  );
}
